import {
    CREATE_FEEDBACK_DETAILS_REQUEST,
    CREATE_FEEDBACK_DETAILS_SUCCESS,
    CREATE_FEEDBACK_DETAILS_FAILURE,
    DELETE_FEEDBACK_DETAILS_REQUEST,
    DELETE_FEEDBACK_DETAILS_SUCCESS,
    DELETE_FEEDBACK_DETAILS_FAILURE,
    FETCH_SINGLE_FEEDBACK_DETAILS_REQUEST,
    FETCH_SINGLE_FEEDBACK_DETAILS_SUCCESS,
    FETCH_SINGLE_FEEDBACK_DETAILS_FAILURE,
    FETCH_FEEDBACK_DETAILS_REQUEST,
    FETCH_FEEDBACK_DETAILS_SUCCESS,
    FETCH_FEEDBACK_DETAILS_FAILURE,
    UPDATE_FEEDBACK_DETAILS_REQUEST,
    UPDATE_FEEDBACK_DETAILS_SUCCESS,
    UPDATE_FEEDBACK_DETAILS_FAILURE,
    RESET_FEEDBACK_DETAILS_INFO,
    CREATE_FEEDBACK_DETAILS_FORM,
    UPDATE_FEEDBACK_DETAILS_FORM,
    FETCH_FEEDBACK_DATA_FROM_PROPERTY_SUCCESS,
    FETCH_FEEDBACK_DATA_FROM_PROPERTY_REQUEST
} from './feedbackDetails.actionType';

export const FEEDBACK_DETAILS = 'feedbackDetails';

let initialState = {
    loading: false,
    feedbackDetails: [],
    feedbackType: [],
    feedbackStatus: [],
    feedbackDetailsform: {},
    selectedState: {},
    errorMessage: ''
};

export let feedbackDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_FEEDBACK_DETAILS_REQUEST:
        case CREATE_FEEDBACK_DETAILS_REQUEST:
        case UPDATE_FEEDBACK_DETAILS_REQUEST:
        case FETCH_SINGLE_FEEDBACK_DETAILS_REQUEST:
        case DELETE_FEEDBACK_DETAILS_REQUEST:
        case FETCH_FEEDBACK_DATA_FROM_PROPERTY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FEEDBACK_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackDetails: updatePayload
            };
        case FETCH_FEEDBACK_DATA_FROM_PROPERTY_SUCCESS:
            if (payload == 50) {
                return {
                    ...state,
                    loading: false,
                    feedbackStatus: updatePayload
                };
            } else if (payload == 51) {
                return {
                    ...state,
                    loading: false,
                    feedbackType: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_FEEDBACK_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackDetailsform: {}
            };
        case UPDATE_FEEDBACK_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackDetailsform: {}
            };
        case FETCH_SINGLE_FEEDBACK_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackDetailsform: {
                    ...updatePayload,
                    fldActualCompletedDate: updatePayload.fldActualCompletedDate && updatePayload.fldActualCompletedDate.split('T')[0],
                    fldDropDate: updatePayload.fldDropDate && updatePayload.fldDropDate.split('T')[0],
                    fldPlanCompletiondate: updatePayload.fldPlanCompletiondate && updatePayload.fldPlanCompletiondate.split('T')[0],
                    fldPlanStartDate: updatePayload.fldPlanStartDate && updatePayload.fldPlanStartDate.split('T')[0]
                }
            };
        case DELETE_FEEDBACK_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackDetailsform: {}
            };
        case RESET_FEEDBACK_DETAILS_INFO:
            return {
                ...state,
                feedbackDetailsform: {}
            };
        case CREATE_FEEDBACK_DETAILS_FORM:
        case UPDATE_FEEDBACK_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                feedbackDetailsform: {
                    ...state.feedbackDetailsform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FEEDBACK_DETAILS_FAILURE:
        case CREATE_FEEDBACK_DETAILS_FAILURE:
        case UPDATE_FEEDBACK_DETAILS_FAILURE:
        case FETCH_SINGLE_FEEDBACK_DETAILS_FAILURE:
        case DELETE_FEEDBACK_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
